module.exports = __webpack_public_path__ + "static/prochile-39356a85bf69d37bd04c70c166e7eba9.svg";